module.exports = __webpack_public_path__ + "img/desktop@2x.ab3de252.jpg";